import { z } from 'zod';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { NotNullNumberSchema } from '@/std/schema';
import { EStatus } from '@/types/enum';
import { FormaPagamentoClassificacao } from './FormaPagamentoClassificacao';

export const FormaPagamentoSchema = z.object({
    fop_classificacao: z.enum(FormaPagamentoClassificacao),
    fop_cobranca_integrada: z.enum(['S', 'N']).default('S'),
    fop_descricao: z.string(),
    fop_dias_intervalo: z.number().nullable(),
    fop_empresa_idpk: z.number().nullable(),
    fop_financeiro_conta_idpk: z.number().nullable(),
    fop_idpk: z.number(),
    fop_numero_maximo_parcelas: NotNullNumberSchema,
    fop_status: z.enum(EStatus),
    fop_ultima_alteracao: z.string().nullable(),
});

export type FormaPagamento = z.infer<typeof FormaPagamentoSchema>;

export type FormaPagamentoBody = PartialUndefinedOrNull<
    Omit<FormaPagamento, 'fop_empresa_idpk' | 'fop_ultima_alteracao'>
>;
